import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageContext } from 'pageContext'
import { Card } from 'packages/eid-ui'
import { Box } from '@mui/material'
import { EidAutocomplete } from 'packages/eid-controls'
import { Icon } from 'packages/eid-icons'
import { isNilOrEmpty } from 'packages/core'
import { useRegistry } from 'core/useRegistry'

const SubjectTypeOptionComponent = EidAutocomplete.getOptionComponent({
    type: 'label',
    labelProp: 'friendlyName',
})

const queryParams = {
    take: 20,
}

const getOptionLabel = (option) => option.friendlyName

const SubjectTypeFilter = () => {
    const { t } = useTranslation()
    const [state, dispatch] = usePageContext()

    const registry = useRegistry()
    const subjectTypeInstance = registry.getSubjectType(state.subjectType?.name)

    const SubjectFilterComponent = state.subjectType
        ? subjectTypeInstance.filterComponent
        : undefined

    const subjectFilter = SubjectFilterComponent && (
        <SubjectFilterComponent subjectType={state.subjectType} />
    )

    const subjectType = (
        <Box padding="18px">
            <EidAutocomplete.New
                placeholder={t('AnySubjectType')}
                url={'/api/subjectTypes'}
                queryParams={queryParams}
                getOptionLabel={getOptionLabel}
                dedupingInterval={60000}
                value={state.subjectType ? state.subjectType : null}
                optionComponent={SubjectTypeOptionComponent}
                clearIcon={
                    !isNilOrEmpty(state.subjectType) && (
                        <Icon
                            name="Close"
                            color="#959598"
                            onClick={() =>
                                dispatch({
                                    type: 'SET_MULTIPLE_PROPS',
                                    payload: {
                                        subjectType: null,
                                        subject: null,
                                    },
                                })
                            }
                        />
                    )
                }
                onChange={(_, value) => {
                    dispatch({
                        type: 'SET_MULTIPLE_PROPS',
                        payload: {
                            subjectType: value,
                            subject: null,
                        },
                    })
                }}
            />
        </Box>
    )

    return (
        <Card
            cardTitle={t('FilterBySubjectType')}
            color="#fff"
            collapsible
            expanded={Boolean(state.subjectType)}
        >
            {subjectType}
            {subjectFilter}
        </Card>
    )
}

export default SubjectTypeFilter
